export const DEFAULT_LOS_ID = 'UnityDirectID';
export const vin = {
  length: 17
};
export const notForThisAccount = 'Not for this Account';
export const minAFValueForGAP = 1000;
export const defaultCollateralType = 0;
export const defaultOtherCollateralType = 1;
export const otherCollateralOdometer = 1;
export const motorCycleTypes = [1, 2];
export const defaultCoBorrowerDob = '9999-12-31';
export const VEHICLE_TYPE_OTHER = 'Other';

export const nameValidPattern =
  '^(?!\\s)[A-Za-z0-9-&.@#\'"]*( [A-Za-z0-9-&.@#\'"]+)*(S*)?$';
export const addressCityValidPattern = '^(?!\\s)[ A-Za-z0-9-\\/\\\\&.@#\'"]*$';
export const accountOrLoanNumberValidPattern = '^(?!\\s)[0-9a-zA-Z- ]*$';
export const validateEmptySpace = '(?!^ +$)^.+$';

export const NAME_MAX_LENGTH = 30;
export const ADDRESS_CITY_MAX_LENGTH = 30;
export const ACCOUNT_LOAN_MAX_LENGTH = 20;
export const INSURANCE_INFO_MAX_LENGTH = 50;
export const BORROWER_EMAIL_MAX_LENGTH = 50;
export const REFERRAL_CODE_MAX_LENGTH = 30;
export const ADDRESS_1_MAX_LENGTH = 50;
export const ADDRESS_2_MAX_LENGTH = 30;

export const MIN_PEP = 1000;
export const MAX_PEP = 150000;
export const defaultProductType = 16;

export const MIN_VPP_MMP = 1;

export const FIRST_SECOND_PAYMENT_DAYS_GAP = 15;

export const DATE_BACK_DAYS = 60;

export const VIN_EP = '/vin';
export const RATES_EP = '/rates';
export const PROPOSALS_EP = '/proposals';
export const BUNDLES_EP = '/bundles';
export const GAPGRAPH_EP = '/gapgraph';
export const PAYMENT_EP = '/payment';
export const BOOKING_EP = '/bookings';
export const RERATING_EP = '/rerating';
export const NO_BUNDLE_ELIGIBLE_MESSAGE =
  'Bundles are no longer eligible due to any of the following not meeting the requirements: Amount Financed, Odometer, Rate, Term, or Vehicle Purchase Price (optional).';

export enum eProductDescriptions {
  mmp = 'Covers the repair or replacement of mechanical parts (in addition to labor) as a result of an unexpected major mechanical breakdowns.',
  vehicleReturn = 'Borrower can return their vehicle due to a qualifying event, owe nothing & the credit remains intact.',
  gap = 'Covers the difference between the Actual Cash Value (ACV) of the vehicle & the unpaid balance of the loan.',
  pep = 'PEP pays the difference between the vehicle purchase price or value on date of finance and the primary insurance settlement subject to the maximum PEP benefit amount.',
  paymentProtection = 'Provides protection for borrower/s & their credit score if he/she is unable to make their loan payment due to the loss of life, a disability or involuntary unemployment.',
  ppm = "Maintenance Benefit Agreement will help ensure long-term operation of your vehicle, by securing your vehicle's future maintenance needs now",
  keyProtection = 'Key Protection offers a portfolio of features and benefits that protect and assist you in the event your keys are lost or stolen, or become inoperable due to destruction, breakdown, or malfunction.'
}

export const PPI_INELIGIBLE_AGE_RULE_MESSAGE =
  'The borrower(s) do not meet the age restriction and therefore is not eligible for Payment Protection.';

export const PPI_PARTIAL_INELIGIBLE_AGE_RULE_MESSAGE =
  'One borrower does not meet the age restriction and therefore is not eligible for Payment Protection. Only single coverage options are available.';

export const PRODUCT_PYRAMID = {
  level1: ['mmp', 'vehicleReturn', 'pep', 'ppm', 'sd', 'keyProtection', 'cvp'],
  level2: ['gap'],
  level3: ['paymentProtection']
};
export const VEHICLE_TYPE = {
  vehicle: 'vehicle',
  otherCollateral: 'other-collateral',
  undetected: 'undetected'
};

export const VAC_VALUE_INCLUDED = 'Included';

export const MAX_OTHER_COLLATERAL_MMS = 50;
export const PANEL_SUMMARY_VAL_MAX_LENGTH = 25;

//ISA
export const ISA_INITIAL_TOP_POSITION_EXPRESS = 89.5;
export const ISA_INITIAL_TOP_POSITION_DIRECT = 158;
export const ISA_BREAKPOINT_FIXED_POSITION = 2300;
export const ISA_BREAKPOINT_MIN = 1460;
export const ISA_BREAKPOINT_MIN_LOS = 1500;
export const DESKTOP_BREAKPOINT_MIN = 992;
export const EXPRESS_SIDEBAR_BREAKPOINT_FOR_HEADER_REDUCTION = 69;
export const EXPRESS_SIDEBAR_DEFAULT_TOP = 16;
export const EXPRESS_SIDEBAR_DEFAULT_TOP_WITH_HEADER = 105;
export const EXPRESS_SIDEBAR_DEFAULT_OFFSET = 35;
export const EXPRESS_SIDEBAR_DEFAULT_HEADER_HEIGHT = 55;
export const EXPRESS_SIDEBAR_DEFAULT_HEIGHT = 123;
export const FOOTER_HEIGHT = 96;

export const NADA_API_ERROR = 'NADA Advanced value data is not found';
export const NOT_AVAILABLE = 'N/A';

export const SSFCU_INSTITUTION_NAME = 'Security Service Federal Credit Union';

export const FORM_CONTROL_STATUS_DISABLED = 'DISABLED';

export const BILLING_STORED_DATA_EXPIRY_DURATION_MS = 4 * 24 * 60 * 60 * 1000; // 4 days
export const BILLING_STORED_DATA_MAX_ENTRIES = 10;

export const ALERT_POLL_TIMER = 3 * 60 * 1000;

export const VEHICLE_OPTIONS = {
  isTurbo: 'TURBO',
  isDiesel: 'DIESEL',
  isAllWheelDrive: 'AWD'
};

export enum CollateralCode {
  GAS_VEHICLE = 110,
  ELECTRIC_VEHICLE = 111,
  OTHER_COLLATERAL_MOTORCYCLE = 113,
  OTHER_COLLATERAL_ATV = 117
}

export enum eEnv {
  LOCAL = 'local',
  DEV = 'dev',
  QA = 'qa',
  BETA = 'beta',
  PROD = 'production'
}
